const basePath = '/admin';
const baseRouterPath = '/admin/dashboard';
const mmrmPath = `${baseRouterPath}/clep`;

const baseProjectPathConfig = {
  mmrm: mmrmPath,
};

export { basePath, baseRouterPath, mmrmPath, baseProjectPathConfig };
